import React from 'react';
import { Button } from '../../BasicComponents/Button';
import type { EmptyStateProps, EmptyStateVariant } from './types';

// ─── Variant class maps ───────────────────────────────────────────────────────

const WRAPPER_CLASSES: Record<EmptyStateVariant, string> = {
  page: 'flex flex-1 flex-col items-center justify-center py-16 px-4 min-h-[320px]',
  section: 'flex flex-col items-center justify-center py-10 px-4',
  inline: 'flex flex-col items-center justify-center py-8 px-4',
  table: 'flex flex-col items-center justify-center py-10 px-4',
};

const ICON_SIZE_CLASSES: Record<EmptyStateVariant, string> = {
  page: 'h-[120px] w-[120px]',
  section: 'h-16 w-16',
  inline: 'h-16 w-16',
  table: 'h-16 w-16',
};

const TITLE_CLASSES: Record<EmptyStateVariant, string> = {
  page: 'text-base font-semibold text-neutral-900 dark:text-neutral-100',
  section: 'text-sm font-semibold text-neutral-900 dark:text-neutral-100',
  inline: 'text-sm font-semibold text-neutral-900 dark:text-neutral-100',
  table: 'text-sm font-semibold text-neutral-900 dark:text-neutral-100',
};

const DESCRIPTION_CLASSES: Record<EmptyStateVariant, string> = {
  page: 'text-sm text-neutral-500 dark:text-neutral-400 max-w-[320px]',
  section: 'text-xs text-neutral-500 dark:text-neutral-400 max-w-[280px]',
  inline: 'text-xs text-neutral-500 dark:text-neutral-400 max-w-[240px]',
  table: 'text-xs text-neutral-500 dark:text-neutral-400 max-w-[240px]',
};

// ─── EmptyState ───────────────────────────────────────────────────────────────

export function EmptyState({
  icon,
  title,
  description,
  action,
  variant = 'page',
}: EmptyStateProps) {
  const iconSizeClass = ICON_SIZE_CLASSES[variant];

  return (
    <div className={WRAPPER_CLASSES[variant]}>
      {icon && (
        <span
          className={`flex items-center justify-center text-neutral-300 dark:text-neutral-600 mb-4 ${iconSizeClass}`}
          aria-hidden="true"
        >
          {icon}
        </span>
      )}

      <p className={`${TITLE_CLASSES[variant]} text-center`}>{title}</p>

      {description && (
        <p className={`${DESCRIPTION_CLASSES[variant]} text-center mt-1`}>{description}</p>
      )}

      {action && (
        <div className="mt-4">
          <Button variant="primary" size={variant === 'page' ? 'md' : 'sm'} onClick={action.onClick}>
            {action.label}
          </Button>
        </div>
      )}
    </div>
  );
}
